import { SVGComponentPropsType } from 'assets/types';
import colors from 'styles/colors';

const defaultSize = 14;

const ReadyStatusIcon = ({
  size = defaultSize,
  color = colors.agreementStatusDraft,
  ...props
}: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path
      d="M.308 6.256L6.256.308c.411-.41 1.077-.41 1.488 0l5.948 5.948c.41.411.41 1.077 0 1.488l-5.948 5.948c-.411.41-1.077.41-1.488 0L.308 7.744a1.052 1.052 0 0 1 0-1.488z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

export default ReadyStatusIcon;
